import React, { useState, useEffect } from "react";
import Image1 from "../../assests/AboutUsHero.webp";
import Image2 from "../../assests/Slider2.webp";
import Image3 from "../../assests/Slider3.webp";
import Image4 from "../../assests/Slider4.webp";
import Image5 from "../../assests/SLider5.webp";
import Image8 from "../../assests/Slider8.webp";
import Image9 from "../../assests/Slider9.webp";
import Image10 from "../../assests/Slider10.webp";
import Image12 from "../../assests/slider12.png";
import "./HomeSlider.css";

const Slider = () => {
  const slides = [

    {
      image: Image8,
      alt: "Isbc",
      text: "Slide 5",
    },
     {
      image: Image12,
      alt: "Isbc",
      text: "Slide 12",
    },
    {
      image: Image9,
      alt: "Isbc",
      text: "Slide 5",
    },
    {
      image: Image10,
      alt: "Isbc",
      text: "Slide 5",
    },
  
    {
      image: Image2,
      alt: "ISBC",
      text: "Slide 1",
    },
    {
      image: Image1,
      alt: "Isbc",
      text: "Slide 2",
    },
    {
      image: Image3,
      alt: "ISBC",
      text: "Slide 3",
    },
    {
      image: Image4,
      alt: "ISBC",
      text: "Slide 4",
    },
    {
      image: Image5,
      alt: "Isbc",
      text: "Slide 5",
    },
      {
      image: Image12,
      alt: "Isbc",
      text: "Slide 12",
    },

  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  // auto-scroll to the next slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((currentSlide + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [currentSlide, slides.length]);

  return (
    <div className="slider">
      <div className="slides">
        {slides.map((slide, index) => (
          <div
            className={
              index === currentSlide ? "slide active" : "slide inactive"
            }
            key={index}
          >
            <img src={slide.image} alt={slide.alt} />
            {/* <div className="slide-text">{slide.text}</div> */}
          </div>
        ))}
      </div>

      {/* <button className="prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="next" onClick={nextSlide}>
        &#10095;
      </button> */}
    </div>
  );
};

export default Slider;
